module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r7n2r5n-1c53b14e55a2cff9bebf53ce52273af4.svg";